module.exports = __webpack_public_path__ + "media/images/athletes/3428-c80102e24e652679bc44fcf4ce5afbe7.png";